import { useState } from "react"

interface Props {
  src: string
  alt: string
  className?: string
  skeletonClassName?: string
  onClick?: () => void
}

export default function SkeletonImage({ src, alt, className, skeletonClassName, onClick }: Props) {
  const [loaded, setLoaded] = useState(false)

  return (
    <>
      {!loaded && (
        <div
          className={`skeleton-shimmer ${skeletonClassName ?? "absolute inset-0"}`}
        />
      )}
      <img
        src={src}
        alt={alt}
        onClick={onClick}
        className={`${className} transition-opacity duration-500 ${loaded ? "opacity-100" : "opacity-0"}`}
        onLoad={() => setLoaded(true)}
      />
    </>
  )
}
